import { render } from "./SortList.vue?vue&type=template&id=7a1e0504&ts=true"
import script from "./SortList.vue?vue&type=script&lang=ts"
export * from "./SortList.vue?vue&type=script&lang=ts"

import "./SortList.vue?vue&type=style&index=0&id=7a1e0504&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__